import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { HOTLINE_PRO_MYPAGE_LIST_ITEM_TYPE_NEW, HOTLINE_PRO_MYPAGE_LIST_ITEM_TYPE_SCHEDULED, } from '@/feature/hotline/professional/mypage/component/HotlineProMypageList/constant';
import { HotlineProMypageListItem, HotlineProMypageListItemSkeleton, } from '@/feature/hotline/professional/mypage/component/HotlineProMypageList/HotlineProMypageListItem';
import { hotlineProMypageListStyle } from '@/feature/hotline/professional/mypage/component/HotlineProMypageList/style';
import { useArrayWithIndex } from '@/hooks/array/useArrayWithIndex';
/** 0件表示のテキスト */
const noDataText = {
    [HOTLINE_PRO_MYPAGE_LIST_ITEM_TYPE_NEW]: '現在、新着相談はありません',
    [HOTLINE_PRO_MYPAGE_LIST_ITEM_TYPE_SCHEDULED]: '現在、相談予定はありません',
};
/**
 * 匿名コンサルホットライン マイページ一覧
 */
export const HotlineProMypageList = (props) => {
    const { className = '', disabled = false, list, loading = false, type, } = props;
    const dummies = useArrayWithIndex(3);
    const style = hotlineProMypageListStyle();
    // ローディング表示
    if (loading && !list) {
        return (_jsx("ul", Object.assign({ className: style.base({ class: className }) }, { children: dummies.map(({ index: key }) => (_jsx(HotlineProMypageListItemSkeleton, { className: style.item(), type: type }, key))) })));
    }
    // データが取得できなかった場合
    if (!list) {
        return (_jsx("div", Object.assign({ className: style.onlyText() }, { children: "\u30C7\u30FC\u30BF\u304C\u53D6\u5F97\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u6642\u9593\u3092\u7F6E\u3044\u3066\u304B\u3089\u3084\u308A\u76F4\u3059\u304B\u3001\u7BA1\u7406\u8005\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002" })));
    }
    // 0件の場合
    if (list.length === 0) {
        return _jsx("div", Object.assign({ className: style.onlyText() }, { children: noDataText[type] }));
    }
    // 新着相談 表示
    if (type === HOTLINE_PRO_MYPAGE_LIST_ITEM_TYPE_NEW) {
        return (_jsx("ul", Object.assign({ className: style.base({ class: className }) }, { children: list.map((item) => (_jsx(HotlineProMypageListItem, { className: style.item(), disabled: disabled, item: item, type: HOTLINE_PRO_MYPAGE_LIST_ITEM_TYPE_NEW }, item.id))) })));
    }
    // 相談予定 表示
    return (_jsx("ul", Object.assign({ className: style.base({ class: className }) }, { children: list.map((item) => (_jsx(HotlineProMypageListItem, { className: style.item(), disabled: disabled, item: item, type: HOTLINE_PRO_MYPAGE_LIST_ITEM_TYPE_SCHEDULED }, item.id))) })));
};
